<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form [formGroup]="queueInfo" (ngSubmit)="handleSave()">
    <div class="caller-edit-container" onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field property">
          <div class="mat-body-1 property-header">Announce hold time</div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="announceFrequency">
              @for (freq of announceFrequencies; track freq) {
              <mat-option [value]="freq">
                {{ freq === "0" ? "Never" : "Every " + freq + " seconds" }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
        <section class="with-mat-form-field property moh-prop-flex">
          <div class="mat-body-1 property-header">While on hold caller hears</div>
          <mat-form-field
            appearance="outline"
            class="moh-field"
            onsip-form-field-flush-outline
            onsip-hide-subscript-wrapper
          >
            <mat-select formControlName="musicSource">
              @for (source of allMusicSources; track source) {
              <mat-option [value]="source">
                {{ source.name }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
          <button
            class="add-item-btn"
            color="primary"
            type="button"
            mat-button
            (click)="createMusicSource()"
          >
            <mat-icon>add</mat-icon>
            <span>Add music source</span>
          </button>
        </section>
      </div>
      <div class="duration-col">
        <section class="with-mat-form-field property">
          <div class="mat-body-1 property-header">Caller timeout</div>
          <div class="duration-grid">
            <mat-form-field class="duration-select" appearance="outline">
              <mat-select formControlName="callerTimeout">
                @for (timeout of callerTimeouts; track timeout) {
                <mat-option [value]="timeout">
                  {{ timeout }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            <span class="seconds-text duration-second-col">seconds</span>
          </div>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field property">
          <div class="mat-body-1 property-header">Failover address</div>
          <onsip-address-autocomplete
            #failloverAddress
            formControlName="failoverAddress"
            name="failoverAddress"
          >
          </onsip-address-autocomplete>
        </section>
        <section class="with-mat-form-field property">
          <div class="mat-body-1 property-header">
            Escape voicemail box
            <mat-icon
              [matTooltip]="
                'When there are no agents logged into the queue, callers are redirected to an escape voicemail box.'
              "
              matTooltipClass="onsip-tooltip-background"
              [matTooltipPosition]="'above'"
              class="tool-tip-icon"
              >help_outline
            </mat-icon>
          </div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="escapeAddress">
              <mat-option [value]="'None'"> None </mat-option>
              @for (voicemail of allVoicemailBoxes; track voicemail) {
              <mat-option [value]="voicemail">
                {{ voicemail.name + " (Voice Mailbox)" }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button color="primary" type="button" (click)="cancel()">Cancel</button>
      <button class="submit-button" type="submit" mat-flat-button color="primary">
        Save changes
      </button>
    </div>
  </form>
</onsip-loading-container>
